import { useState, useEffect } from 'react';
import { noop, isUndefined } from 'lodash';

export const useFavoriteButton = ({ onChange = noop, isFavorite = false }) => {
    const [isActive, setIsActive] = useState(isFavorite);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (isFavorite !== isActive) {
            setIsActive(isFavorite);
        }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isFavorite]);

    const updateActiveState = async(e, active) => {
        e.preventDefault();

        if (isLoading) {
            return;
        }

        let changeAllowed;
        setIsLoading(true);

        try {
            changeAllowed = await onChange(active);
        } catch {
            changeAllowed = false;
        }

        setIsLoading(false);

        if (!isUndefined(changeAllowed) && !changeAllowed) {
            return;
        }
        setIsActive(active);
    };

    return {
        isActive,
        updateActiveState
    };
};
